export enum WireHomeSumInsuredType {
  Estimated = 'EstimatedValue',
  Agreed = 'AgreedValue',
}

type WireHomeValues = {
  estimated: number;
  lowAgreed: number;
  highAgreed: number;
  agreed: number;
  selected: WireHomeSumInsuredType;
};

export type WireHome = {
  id: string;
  values: WireHomeValues;
};
